import {session} from 'wix-storage';

$w.onReady(function () {
	const formId = Math.random().toString();
	console.log(formId);
	$w('#formid').value = formId;
	session.setItem('formId',formId);
	console.log($w('#formid').value);
	console.log(session.getItem('formId'));
    

    // if (formId === "") 
    // {
	// 	console.log("inside the if of empty string");
    //     //Generate an unique id for the multi-page form
    //     formId = Math.random().toString();
	// 	console.log("inside the if of empty string, this is the formId " + formId);
	// 	console.log(formId);

    //     //Save the form id to browser session memory
    //     session.setItem('formId',formId);
	// 	console.log("inside the if of empty string, this is the session " + session.getItem('formid'));
    // }

	// if (formId === null) 
    // {
	// 	console.log("inside the if of null");
    //     //Generate an unique id for the multi-page form
    //     formId = Math.random().toString();
	// 	console.log("inside the if of null, this is the formId " + formId);
	// 	console.log(formId);

    //     //Save the form id to browser session memory
    //     session.setItem('formId',formId);
	// 	console.log("inside the if of null, this is the session " + session.getItem('formid'));
    // }

	// console.log("outside of the if " + formId);
    // //Assign formId in session memory to the form on page
    // $w('#formid').value = formId;
	// console.log("this is inside the form " + $w('#formid').value);
});